import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from 'app/app.component';
import { createAppConfig, isSentryEnabled } from 'app/app.config';
import { loadRuntimeConfig } from 'app/core/runtime-config/runtime-config';
import { environment } from 'environments/environment';

const bootstrap = async (): Promise<void> => {
	await loadRuntimeConfig();

	if (isSentryEnabled()) {
		Sentry.init({
			dsn: 'https://01f8dd59204bd270abc30faa97d1d5f4@o4511430988267520.ingest.us.sentry.io/4511431219347456',
			environment: environment.env,
			integrations: [Sentry.browserTracingIntegration()],
			tracesSampleRate: 1.0,
			tracePropagationTargets: [environment.apiUrl],
			dataCollection: {
				userInfo: true,
				cookies: false,
				httpHeaders: {
					request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
					response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
				},
				httpBodies: [],
				urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
				genAI: { inputs: false, outputs: false },
				databaseQueryData: false,
				graphQL: { document: false, variables: false },
			},
			attachStacktrace: true,
		});
	}

	await bootstrapApplication(AppComponent, createAppConfig());
};

bootstrap().catch((err) => console.error(err));
